
import Load from './components/load/Load'
import Container from './components/container/Container'
import './App.css'
import AppProvider from './context/AppProvider'

const App = () => {

  return (
    <AppProvider>
      <div className="App">
        <Load />
        <Container />
      </div>
    </AppProvider>
    
  )
}

export default App